module.exports = __webpack_public_path__ + "img/kx5600-char-4.f55c1957.png";